import gql from 'graphql-tag';

export const CALCULATE_POST_MALONE_SCORE_MUTATION = gql`
  mutation CalculatePostMaloneScoreMutation(
    $externalProjectId: ID!
    $text: String!
    $assetType: PostMaloneAssetTypeEnum!
  ) {
    calculatePostMaloneScore(externalProjectId: $externalProjectId, text: $text, assetType: $assetType) {
      engagementScore
      errors
    }
  }
`;
